/**
 * @generated SignedSource<<110d18a72b960c56008858969b88f0ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useProductizedServicePreview_productizedService$data = {
  readonly publishedAt: ContraAPIScalars.DateTime | null;
  readonly " $fragmentType": "useProductizedServicePreview_productizedService";
};
export type useProductizedServicePreview_productizedService$key = {
  readonly " $data"?: useProductizedServicePreview_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"useProductizedServicePreview_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useProductizedServicePreview_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "63b765180b9737bec63d448358834833";

export default node;
